import './documents-dialogs-service.service';
import './globals-api.factory';
import './package-configuration-dialogs.service';
import './package-configuration-service.service';
import './package-configurations-requests.service';
import './preferences-api.factory';
import './settings-requests.service';
import './preferences-dialogs-service.service';
import './preferences-requests.service';
import './reminders-dialogs-service.service';
import './settings-alerts.service';
import './settings-api.factory';
import './settings-service.service';
import './absence-reasons-dialogs.service';
import './break-types-dialogs.service';
import './travel-time-rule-alerts.service';
import './travel-time-rule-api.factory';
import './travel-time-rule-dialogs.service';
import './travel-time-rule-requests.service';
import './travel-time-rule-service.service';
import './vehicle-status-change-reasons-dialogs-service.service';
import './roles-groups-dialogs.service'
import './site-providers-dialogs.service';
